import { useQuery } from "@tanstack/vue-query";

import { getReceipt } from "@/api";
import { useSessionExpiredStore } from "@/stores/useSessionExpiredStore";

export function useReceipt(id: string) {
  return useQuery({
    queryKey: ["receipt", id],
    queryFn: async () => {
      const { response, data, error } = await getReceipt(id);

      if (response.status === 403) {
        useSessionExpiredStore().setSessionExpired(true);
      }

      if (error) {
        throw error;
      }

      return data;
    },
    staleTime: 1000 * 60 * 1, // 1 minutes
    enabled: !!id,
  });
}
